import {observer, React} from '@api'
import {EraserIcon, TDShapeType, ToolButtonWithTooltip, useWhiteboardStore} from '@modules/whiteboard'
import {ArrowTopRightIcon, CursorArrowIcon, Pencil1Icon, Pencil2Icon, TextIcon} from '@radix-ui/react-icons'
import {Panel} from '~components/Panel'
import {shapeIcons, ShapesMenu} from './ShapesMenu'
import * as css from './PrimaryTools.css'
import { Icon } from '@blueprintjs/core'

export const PrimaryTools = observer(function PrimaryTools(): JSX.Element {
  const {appState: {activeTool}, tools: {isToolLocked, selectTool}} = useWhiteboardStore()

  return (
    <Panel side="center" className={css.root}>
      <ToolButtonWithTooltip
        kbd={'1'}
        label={'Select'}
        onClick={() => selectTool('select')}
        isActive={activeTool === 'select'}
      >
        <CursorArrowIcon />
      </ToolButtonWithTooltip>
      <ToolButtonWithTooltip
        kbd={'2'}
        label={'Draw'}
        onClick={() => selectTool('draw')}
        isActive={activeTool === 'draw'}
      >
        {shapeIcons.draw}
      </ToolButtonWithTooltip>
      <ToolButtonWithTooltip
        kbd={'h'}
        label={'highlighter'}
        onClick={() => selectTool('highlighter')}
        isActive={activeTool === 'highlighter'}
      >
        {shapeIcons.highlighter}
      </ToolButtonWithTooltip>
      <ToolButtonWithTooltip
        kbd={'3'}
        label={'Erase'}
        onClick={() => selectTool('erase')}
        isActive={activeTool === 'erase'}
      >
        <EraserIcon />
      </ToolButtonWithTooltip>
      <ShapesMenu />
      <ToolButtonWithTooltip
        kbd={'f'}
        label={'Frame'}
        onClick={() => selectTool('frame')}
        isLocked={isToolLocked}
        isActive={activeTool === 'frame'}
      >
        {shapeIcons.frame}
      </ToolButtonWithTooltip>

      <ToolButtonWithTooltip
        kbd={'6'}
        label={'Arrow'}
        onClick={() => selectTool('arrow')}
        isLocked={isToolLocked}
        isActive={activeTool === 'arrow'}
      >
        {shapeIcons.arrow}
      </ToolButtonWithTooltip>
      <ToolButtonWithTooltip
        kbd={'7'}
        label={'Textbox'}
        onClick={() => selectTool('text')}
        isLocked={isToolLocked}
        isActive={activeTool === 'text'}
      >
        {shapeIcons.text}
      </ToolButtonWithTooltip>
      <ToolButtonWithTooltip
        kbd={'8'}
        label={'Sticky Note'}
        onClick={() => selectTool('sticky')}
        isActive={activeTool === 'sticky'}
      >
        {shapeIcons.sticky}
      </ToolButtonWithTooltip>
    </Panel>
  )
})



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/ToolsPanel/PrimaryTools.tsx